module.exports = __webpack_public_path__ + "fonts/voicecall_38x38.98ee4e6eac4e482dc8b2db9eadafb031.png?";


//////////////////
// WEBPACK FOOTER
// ./~/@okta/okta-signin-widget/dist/img/icons/mfa/voicecall_38x38.png
// module id = 799
// module chunks = 9